import dayjs from "dayjs";

//* Exmaple format "14 May 2024" *//
export const formatDayMonthYear = (date) => dayjs(date).format("DD MMM YYYY") || "";

//* Exmaple format "14.05.2024" *//
export const formatDayMonthYearWidthDot = (date) => dayjs(date).format("DD.MM.YYYY") || "";
